import React from 'react';
import { makeStyles } from '@material-ui/core';
import MuiSlider, { SliderProps } from '@material-ui/core/Slider';

import CustomValueLabel from './ValueLabel';

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.secondary.main,
    paddingTop: 0,
    paddingBottom: 0,
  },
  rail: {
    height: '4px',
  },
  track: {
    height: '4px',
  },
  thumb: {
    marginTop: '-4px',
  },
  'thumb--donut': {
    background: theme.palette.common.white,
    border: '4px solid currentColor',
    height: '16px',
    width: '16px',
    top: '-1px',
  },
  mark: {
    width: '4px',
    height: '4px',
    borderRadius: '2px',
    transform: 'translateX(-2px)',
  },
}));

interface Props {
  kind?: 'default' | 'mui' | 'donut';
}

const Slider: React.FC<SliderProps & Props> = ({
  kind = 'default',
  ...rest
}) => {
  const classes = useStyles();

  const sliderStyles = React.useMemo(() => {
    const { root, rail, track, thumb, mark } = classes;
    const sliderClasses = { root, rail, track, thumb, mark };

    if (kind === 'default') {
      return sliderClasses;
    }
    if (kind === 'donut') {
      return {
        ...sliderClasses,
        thumb: classes['thumb--donut'],
      };
    }

    return undefined;
  }, [kind, classes]);

  const labelComponent = React.useMemo(() => {
    if (kind === 'default' || kind === 'donut') {
      return CustomValueLabel;
    }

    return undefined;
  }, []);

  return (
    <MuiSlider
      classes={sliderStyles}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      ValueLabelComponent={labelComponent}
      {...rest}
    />
  );
};

export default Slider;
